import adjustEndTime from '../../../containers/ActForm/UIOptimizations/AdjustEndTime/AdjustEndTime';

const associatedUIOptimizations = [adjustEndTime];

const adjustEndTimeOptimization = { associatedUIOptimizations };

export default adjustEndTimeOptimization;
